import { get } from '../../http';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getOrders ({ rootState }, userId) {
    const global = rootState.login.adType !== 'radio' ? 'global-order' : 'order'
    const params = {}

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    // if (rootState.login.adType !== 'radio') {
    //   params.advertiser_id = userId
    // }

    const res = await get(`/ad-user/${global}/get-orders-for-ad`, params);
    return res.data;
  },
  async getOrderData ({ state, commit, rootState }, id) {
    const global = rootState.login.adType !== 'radio' ? 'global-order' : 'order'
    const params = {}

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/ad-user/${global}/get-order-info/${id}`);
    return res.data;
  },
  async getAdList ({ state, rootState, commit }, params) {
    rootState.global.advertise.page.loading = true;
    const global = rootState.login.adType !== 'radio' ? 'global/' : ''

    if (rootState.login.adType === 'global') {
      params.medias = -1
    }

    const res = await get(`/ad-user/${global}ads`, params);
    const {
      data: { data, total },
      header
    } = res.data;
    rootState.global.advertise.page.setPageData(
      {
        header,
        data: data,
        total: total
      },
      false
    );
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
